export const RESCUE_URL =
  typeof window !== 'undefined' && /testnet/i.test(window.location.hostname)
    ? 'https://staging.dex-fe-rescue.pages.dev/'
    : 'https://recovery.perpl.xyz/';

export const TWITTER_URL = 'https://x.com/perpltrade';
export const DISCORD_URL = 'https://discord.gg/perpl';
export const TESTNET_URL = 'https://testnet.perpl.xyz';

const PERPL_DOCS_BASE_URL = 'https://docs.perpl.xyz/';
export const DOCS_URL = PERPL_DOCS_BASE_URL;
export const REFERRALS_DOCS_URL = `${PERPL_DOCS_BASE_URL}exchange/referrals`;
export const BUILDER_CODES_DOCS_URL = `${PERPL_DOCS_BASE_URL}resources/for-developers/api/builder-codes`;
export const POINTS_DOCS_URL = `${PERPL_DOCS_BASE_URL}exchange/points`;
export const TOURNAMENT_DOCS_URL = `${PERPL_DOCS_BASE_URL}exchange/tournaments`;
export const tournamentDocsUrl = (tournamentNumber?: number): string =>
  tournamentNumber != null ? `${TOURNAMENT_DOCS_URL}/tournament-${tournamentNumber}` : TOURNAMENT_DOCS_URL;

// Trading-API reference, hosted on GitHub (separate from the docs site above).
export const API_DOCS_URL = 'https://github.com/PerplFoundation/api-docs';
